module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-255.de51366.woff2";